import { Loader } from 'BMapsSrc/Loader';
import TabInfo from '../../../../common/TabController/TabInfo';
import { CDDVImportTab } from '../../../../../plugin/CDDV/CDDVTab';
import EnterMolDataTab from './EnterMolDataTab';
import CompoundGenerationTab from './CompoundGenerationTab';
import { JobsCompoundsTab } from './JobsCompoundsTab';

const tabs = [
    new TabInfo(
        'import_dragpaste_tab',
        'Enter Mol. Data',
        EnterMolDataTab,
    ),
    new TabInfo(
        'import_cddv_tab',
        'CDD Vault',
        CDDVImportTab,
    ),

];

if (Loader.AllowLabFeatures) {
    tabs.push(
        new TabInfo(
            'compound_generation_tab',
            'Generate Compounds',
            CompoundGenerationTab,
        ),
        new TabInfo(
            'jobs_compounds_tab',
            'Compound Job Results',
            JobsCompoundsTab,
            {
                ModalPaneProps: {
                    style: {
                        height: '100%',
                        maxWidth: 'none',
                    },
                },
            }
        )
    );
}

export default tabs;
